module.exports = __webpack_public_path__ + "static/media/wyse.69931661.png";